import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: true,
        config: {
            baseUrlApi: process.env.VUE_APP_BASE_URL,
        }
    },
    actions: {

    },
    mutations: {
        
    },
    getters: {
        
    }
})